import { render, staticRenderFns } from "./projectsContracts.vue?vue&type=template&id=b9efad68&scoped=true"
import script from "./projectsContracts.vue?vue&type=script&lang=js"
export * from "./projectsContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9efad68",
  null
  
)

export default component.exports